import { Videos, Videos_Filter } from 'src/graphql/schema.graphql';
import { speakersGqlFragment } from 'src/modules/materials/graphql/speakers.fragment';
import { tagsGqlFragment } from 'src/modules/materials/graphql/tags.fragment';
import { productsGqlFragment } from 'src/modules/products/graphql/products.fragment';
import { shortcodesGqlFragment } from 'src/modules/videos/graphql/videos-shortcodes.fragment';
import { gql, GqlFragment } from 'src/utils/gql/query';

export const videoDetailsGqlQuery: GqlFragment<
  { videos: Videos[] },
  { filters: Videos_Filter; sort: string[]; limit: number }
> = gql`
  ${productsGqlFragment}
  ${shortcodesGqlFragment}
  ${speakersGqlFragment}
  ${tagsGqlFragment}

  query VideoDetailsQuery(
    $filters: videos_filter
    $sort: [String]
    $limit: Int
  ) {
    videos(filter: $filters, sort: $sort, limit: $limit) {
      id
      slug
      date_created

      bodyParts {
        bodyParts_id {
          slug
        }
      }
      subjects {
        subjects_id {
          slug
        }
      }
      translations {
        languages_code {
          code
        }
        name
        description
        excerpt
      }
      audioLanguages {
        languages_code {
          code
          name
        }
      }
      thumbnail {
        id
      }
      products {
        products_id {
          ...products
        }
      }
      disclaimer
      source {
        id
        url
        format
        duration
        startDate
        endDate
      }
      tags {
        tags_id {
          ...tags
        }
      }
      shortcodes {
        ...shortcodes
      }
      speakers {
        people_id {
          ...speakers
        }
      }
      attachments {
        attachments_id {
          id
          type
          translations {
            name
            url
            description
            file {
              id
            }
            languages_code {
              code
            }
          }
        }
      }
    }
  }
`;
